import gql from "graphql-tag";
import { toast } from "react-toastify";
import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";

export default async function confirmParcisionBidRequest(
  cid: number,
  estimate1: number,
  estimate2: number,
  estimate3: number,
  wager: number,
  description: string
) {
  try {
    const variables = {
      wager,
      estimate1,
      estimate2,
      estimate3,
      description,
      cid,
    };

    const query = gql`
      query MyQuery(
        $cid: Float!
        $wager: String!
        $estimate1: String!
        $estimate2: String!
        $estimate3: String!
        $description: String!
      ) {
        bidParcisionWallet(
          cid: $cid
          wager: $wager
          estimate1: $estimate1
          estimate2: $estimate2
          estimate3: $estimate3
          description: $description
        ) {
          stats {
            snap
            goptin
            gprize
          }
          local {
            snap
            stage
            estimate1
            estimate2
            estimate3
            wager
            description
            research
            tid
          }
          participants {
            addr
            snap
            estimate1
            estimate2
            estimate3
            wager
            return
            description
            research
          }
          message
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.bidParcisionWallet;
  } catch (error) {
    toast.error("Failed to confirm bid");
    sentryWrappedException(error);
    throw error;
  }
}
